import { z } from "zod";

export const newAddressSchema = z.object({
  place: z.string().default(""),
  street: z.string().default(""),
  extendedAddress: z.string().default(""),
  postOfficeBox: z.string().default(""),
  postalCode: z.string().default(""),
  city: z.string().default(""),
  country: z.string().default("CH"),
});

export const locationSchema = z.object({
  contactId: z.number().nullable().default(null),
  name: z.string().default(""),
  addressId: z.number().nullable().default(null),
  createNewAddress: newAddressSchema,
});

export type NewAddressFormData = z.infer<typeof newAddressSchema>;

export type LocationFormData = z.infer<typeof locationSchema>;

export const defaultLocationFormData: LocationFormData = {
  contactId: null,
  name: "",
  addressId: null,
  createNewAddress: {
    place: "",
    street: "",
    extendedAddress: "",
    postOfficeBox: "",
    postalCode: "",
    city: "",
    country: "CH",
  },
};

/**
 * Cross-field rule the Zod object shape can't express and still stay a plain
 * ZodObject (required by `formAtom`, which reads `schema.shape`): either an
 * existing address is picked, or the new-address panel is filled with its
 * required fields. Mirrors the old `ModalLocationType` POST_SUBMIT listener.
 *
 * `newAddressOpen` is UI-only state (the "Create a new address" collapsible),
 * not part of the submitted data, so it's passed in separately.
 */
export function hasValidAddress(
  data: LocationFormData,
  newAddressOpen: boolean,
): boolean {
  if (newAddressOpen) {
    const { street, postalCode, city } = data.createNewAddress;

    return Boolean(street.trim() && postalCode.trim() && city.trim());
  }

  return data.addressId != null;
}
